import context, { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';

import { IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';

class AccountsComponentInitializer implements IInitializer {
    name: string = 'AccountsComponentInitializer';
    order: number = 0;


    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        var validator = defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-address-validator" */ './AddressValidator.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        });
        app.component('AddressValidator', validator);
        app.component('address-validator', validator);

        var signin = defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-create-or-signin" */ './CreateOrSignin.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        });
        app.component('CreateOrSignin', signin);
        app.component('create-or-signin', signin);

        app.component('account-header', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-account-header" */ './Admin/AccountHeader/AccountHeader.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('account-summary', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-account-summary" */ './Admin/AccountSummary/AccountSummary.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('invite-user', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-invite-user" */ './Admin/InviteUser/InviteUser.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('verify-account', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-verify-account" */ './Admin/VerifyAccount/VerifyAccount.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('account-comments', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-account-comments" */ './Admin/AccountComments/AccountComments.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('account-validation-error', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "comp-accounts-validation-error" */ './Validation/Error/Error.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new AccountsComponentInitializer();
    }
});
